import { render, staticRenderFns } from "./carrelloCategoria.vue?vue&type=template&id=55ea46ce&"
import script from "./carrelloCategoria.vue.ts?vue&type=script&lang=ts&"
export * from "./carrelloCategoria.vue.ts?vue&type=script&lang=ts&"
import style0 from "./carrelloCategoria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports